import React from 'react';

const sizes = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12'
};

export default function Spinner({ size = 'md', className = '' }) {
  return (
    <div className={`${sizes[size]} ${className} animate-spin rounded-full border-2 border-slate-200 border-t-indigo-600 dark:border-slate-700 dark:border-t-indigo-400`} />
  );
}
